export default __webpack_public_path__ + "static/media/logout.f42cd385.svg";